var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('TagInput',{attrs:{"disabled":_vm.disabled,"label":"Copy Names Mode","value":_vm.selectedItems,"items":_vm.copyNameModeOptions},on:{"input":_vm.handleInput}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }